<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader title="Add dealer" title1="Dealer Management" />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Dealer Name <span class="manitory">*</span></label>
                  <b-form-input
                    type="text"
                    v-model="form.dealername"
                    ref="firstInput"
                    placeholder="e.g. ABC Distributors"
                    @keypress.enter="submitForm()"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Contact Person</label>
                  <b-form-input
                    type="text"
                    v-model="form.contactperson"
                    placeholder="Full name"
                    @keypress.enter="submitForm()"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <b-form-input
                    type="text"
                    v-model="form.email"
                    placeholder="email@example.com"
                    @keypress.enter="submitForm()"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Phone <span class="manitory">*</span></label>
                  <b-form-input
                    type="text"
                    v-model="form.phone"
                    placeholder="+91 XXXXX XXXXX"
                    @keypress.enter="submitForm()"
                  />
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <textarea
                    class="form-control"
                    rows="4"
                    v-model="form.address"
                    placeholder="Head office address (optional)"
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="form-group">
                  <label>Remarks</label>
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="form.remarks"
                    placeholder="Any notes about this dealer (optional)"
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-12">
                <div class="assign-branches-wrap">
                  <div class="assign-branches-head">
                    <label>Assign Branches <span class="manitory">*</span></label>
                  </div>
                  <div class="branch-selector">
                    <label
                      v-for="branch in branches"
                      :key="branch.branchid"
                      class="branch-option"
                      :class="{ selected: isBranchSelected(branch.branchid) }"
                    >
                      <input
                        type="checkbox"
                        :value="branch.branchid"
                        v-model="form.branchids"
                      />
                      <span class="branch-box">{{ isBranchSelected(branch.branchid) ? '✓' : '' }}</span>
                      <span class="branch-title">{{ branch.branchname }}</span>
                    </label>
                  </div>
                  <p class="branch-summary">
                    <span>{{ form.branchids.length }}</span> of {{ branches.length }} branches selected
                  </p>
                </div>
              </div>
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Save dealer</a>
                <router-link to="dealerlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';

export default {
  data() {
    return {
      form: {
        dealername: '',
        contactperson: '',
        email: '',
        phone: '',
        address: '',
        remarks: '',
        branchids: [],
      },
      branches: [],
    };
  },
  methods: {
    isBranchSelected(branchId) {
      return this.form.branchids.includes(branchId);
    },
    async getBranches() {
      const response = await axios.get('/v1/branches');
      this.branches = response.data;
    },
    async postData() {
      if (!this.form.dealername) {
        Swal.fire("Please enter the dealer name");
        return;
      }
      if (!this.form.phone) {
        Swal.fire("Please enter the phone number");
        return;
      }
      if (!this.form.branchids.length) {
        Swal.fire("Please select at least one branch");
        return;
      }
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
        axios
          .post('/v1/dealers', {
            ...this.form,
            phone: Number(this.form.phone),
          })
          .then(() => {
            Swal.fire("Dealer created successfully");
            this.$router.push({ path: '/dealerlist' });
          })
          .catch(error => {
            console.log(error);
            Swal.fire(error.response.data.detail);
          });
      }
    },
    submitForm() {
      this.postData();
    }
  },
  async beforeMount() {
    await this.getBranches();
  },
  mounted() {
    this.$refs.firstInput.focus();
  },
  name: "adddealer",
};
</script>
<style scoped>
.assign-branches-wrap {
  border-top: 1px solid #e9ecef;
  margin-top: 10px;
  padding-top: 24px;
}

.assign-branches-head label {
  margin-bottom: 14px;
}

.branch-selector {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.branch-option {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.branch-option input {
  display: none;
}

.branch-option.selected {
  border-color: #ff9f43;
  background: rgba(255, 159, 67, 0.08);
}

.branch-box {
  width: 28px;
  height: 28px;
  border: 1px solid #c7c7c7;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  background: #fff;
  flex-shrink: 0;
}

.branch-option.selected .branch-box {
  background: #ff9f43;
  border-color: #ff9f43;
}

.branch-title {
  font-size: 15px;
  font-weight: 600;
  color: #212b36;
}

.branch-summary {
  margin: 14px 0 0;
  color: #6b7280;
  font-size: 14px;
}

.branch-summary span {
  color: #ff9f43;
  font-weight: 700;
}

@media (max-width: 991px) {
  .branch-selector {
    grid-template-columns: 1fr;
  }
}
</style>
